<script setup lang="ts">
import { z } from 'zod'

definePageMeta({
  layout: 'unauthenticated',
  auth: {
    unauthenticatedOnly: true,
    navigateAuthenticatedTo: '/',
  },
})

const route = useRoute()
const { $i18n } = useNuxtApp()
const queryTypeSchema = z.object({ type: z.union([z.literal('citizen'), z.literal('institution')]) })
const institutionSelfRegister = useRuntimeConfig().public.institutionSelfRegister
const type = computed(() => {
  if (institutionSelfRegister) {
    const validation = queryTypeSchema.safeParse(route.query)
    if (validation.success) {
      return validation.data.type
    }
  }
  return 'citizen'
})

useHead({ title: `${$i18n.t('app.title')} - ${$i18n.t(`button.register.${type.value}`)}` })
</script>

<template>
  <div class="max-w-2xl mx-auto">
    <AccountRegistrationInstitutionPage v-if="type === 'institution'" />
    <AccountRegistrationUserPage v-else />
  </div>
</template>
